import fetch from '@jarvis.oddle/core/tools/fetch'
import { makeQueryString } from '@jarvis.oddle/core/tools/routes'
import { CUST_API_ROOT, origin } from 'config/client'
import {
  loadPreviewThemePath,
  loadThemePath,
  refreshIgTokenPath,
  refreshPreviewIgTokenPath,
  getPageDataPath
} from './server'

const makeOptions = ({ req, payload, method = 'GET' }) => {
  return {
    credentials: 'include',
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cookie: req && req.get('Cookie')
    },
    body: JSON.stringify(payload)
  }
}

export const loadPreviewThemeApi = ({ req, previewToken, v2 }) =>
  fetch(
    `${origin(
      req
    )}${CUST_API_ROOT}${loadPreviewThemePath}${makeQueryString({
      previewToken,
      v2
    })}`
  )

export const loadThemeApi = ({ req, menuId }) =>
  fetch(
    `${origin(req)}${CUST_API_ROOT}${loadThemePath}?menuId=${menuId}`,
    false
  )

export const refreshPreviewIgTokenApi = ({ req, menuId, payload }) =>
  fetch(
    `${origin(req)}${CUST_API_ROOT}${refreshPreviewIgTokenPath(menuId)}`,
    makeOptions({ method: 'POST', payload })
  )

export const refreshIgTokenApi = ({ req, menuId, payload }) =>
  fetch(
    `${origin(req)}${CUST_API_ROOT}${refreshIgTokenPath(menuId)}`,
    makeOptions({ method: 'POST', payload })
  )

export const getPageDataApi = ({ req, menuId, siteId, slug }) =>
  fetch(
    `${origin(req)}${CUST_API_ROOT}${getPageDataPath}${makeQueryString({
      menuId,
      siteId,
      slug
    })}`,
    false
  )
